import AdminConfigCommands from "./AdminConfigCommands";
export default AdminConfigCommands;
